<template>
  <div class="bio-link-youtube" :style="{color: sectionTextColor}">
    <div class="bio-link-youtube-header" v-if="item.title || item.description">
      <v-icon color="#FF0000" size="20" class="mr-2">mdi-youtube</v-icon>
      <div class="bio-link-youtube-header-text">
        <p v-if="item.title" class="bio-link-youtube-title bio-link-title-clamp" :style="{color: sectionTextColor}">{{ item.title }}</p>
        <p v-if="item.description" class="bio-link-youtube-desc" :style="{color: sectionTextColor}">{{ item.description }}</p>
      </div>
    </div>
    <div class="bio-link-youtube-player" v-if="embedUrl">
      <iframe
        :src="embedUrl"
        :title="item.title || 'YouTube'"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        @click.stop
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'YoutubeLinkCard',
  props: {
    item: { type: Object, required: true },
    sectionTextColor: { type: String, default: '#FFFFFF' },
    convertToEmbedUrl: { type: Function, required: true },
  },
  computed: {
    embedUrl: function() {
      return this.item.onlineAddress && this.item.onlineAddress.url ? this.convertToEmbedUrl(this.item.onlineAddress.url) : null
    },
  },
}
</script>

<style scoped>
/* No padding on the outer wrapper - the player fills the card edge to
   edge (per feedback, "a seção do youtube pode ocupar 100% do card").
   Only the header text gets its own inset. */
.bio-link-youtube-header {
  display: flex;
  align-items: flex-start;
  padding: 0.9rem 1rem 0.75rem;
}
.bio-link-youtube-header-text {
  min-width: 0;
}
.bio-link-youtube-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin: 0;
}
.bio-link-youtube-desc {
  font-size: 0.82rem;
  opacity: 0.85;
  margin: 0.15rem 0 0;
}
.bio-link-title-clamp {
  overflow-wrap: break-word;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal !important;
}
.bio-link-youtube-player {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  /* No border-radius of its own - it's edge-to-edge inside
     .bio-content-link-card, whose own overflow:hidden + shapeClass
     already clips it to the card's corners. */
  overflow: hidden;
  cursor: default;
}
.bio-link-youtube-player iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
